import { api } from "./client";

export interface DiscountClientOut {
  id: number;
  name: string;
  percent: number;
  card_number: string | null;
  active_from: string | null;
  active_to: string | null;
  weekdays: number[] | null;
  is_active: boolean;
  // клиентът може да закрива сметки с „Плащане по сметка" (pm=4)
  can_pay_on_account: boolean;
  discount_type: string;
  // отстъпка (намалява цената) или надбавка (увеличава я)
  kind: "discount" | "surcharge";
  group_id: number | null;
  restaurant_ids: (number | string)[];
  created_at: string;
  updated_at: string;
}

export interface DiscountClientListOut {
  items: DiscountClientOut[];
  total: number;
}

export const getDiscountClients = async (
  restaurantName: string,
): Promise<DiscountClientListOut> => {
  const response = await api.get<DiscountClientListOut>("/discounts/clients", {
    params: { restaurant_name: restaurantName },
  });
  return response.data;
};
